export default "__VITE_ASSET__CdRg7f9s__"